import React from "react";
import { Col, Icon, Progress, Row } from "antd";

const SIZE = 256;

export default class Customizer extends React.Component {
  constructor() {
    super();
    this.imgs = { layer1: [], layer2: [], layer3: [], layer4: [], layer5: [] };
    this.customImg = null;
    this.canvas = null;
    this.state = {
      loaded: 0,
      total: -1
    };
    this.isMoleTopSurface = false; // ホクロを一番上のレイヤーにするか
  }

  drawContext = evt => {
    const f = this.props.face;

    this.canvas.getContext("2d").clearRect(0, 0, SIZE, SIZE);
    //console.log(f.layer1);
    this.canvas
      .getContext("2d")
      .drawImage(this.imgs.layer1[f.layer1], 0, 0, SIZE, SIZE);
    //console.log(f.layer2);
    this.canvas
      .getContext("2d")
      .drawImage(this.imgs.layer2[f.layer2], 0, 0, SIZE, SIZE);
    //console.log(f.layer3);
    this.canvas
      .getContext("2d")
      .drawImage(this.imgs.layer3[f.layer3], 0, 0, SIZE, SIZE);
    //console.log(f.layer4);
    this.canvas
      .getContext("2d")
      .drawImage(this.imgs.layer4[f.layer4], 0, 0, SIZE, SIZE);
    //console.log(f.layer5);
    this.canvas
      .getContext("2d")
      .drawImage(this.imgs.layer5[f.layer5], 0, 0, SIZE, SIZE);
  };

  handleImgLoad = (id, type, evt) => {
    this.imgs[type][id] = evt.target;
    this.setState({ loaded: this.state.loaded + 1 });
    this.loadNextImage();
  };

  loadNextImage() {
    const img = new Image(),
      src = this.imgsRefs.shift();
    if (src) {
      img.onload = this.handleImgLoad.bind(this, src.id, src.type);
      img.src = src.src;
      img.onerror = err => {
        this.loadNextImage();
      };
    } else {
      this.customImg.appendChild(this.canvas);
      this.drawContext();
    }
  }

  changePart = (type, n = -1) => {
    const pts = Object.keys(this.imgs[type]);
    const f = this.props.face;
    const part = pts[(pts.indexOf(f[type]) + pts.length + n) % pts.length];
    switch (type) {
      case "layer1":
        f.changeLayer1(part);
        break;
      case "layer2":
        f.changeLayer2(part);
        break;
      case "layer3":
        f.changeLayer3(part);
        break;
      case "layer4":
        f.changeLayer4(part);
        break;
      case "layer5":
        f.changeLayer5(part);
        break;
    }
    this.canvas && this.drawContext();
  };

  pLayer1 = () => this.changePart("layer1", -1);
  nLayer1 = () => this.changePart("layer1", 1);
  pLayer2 = () => this.changePart("layer2", -1);
  nLayer2 = () => this.changePart("layer2", 1);
  pLayer3 = () => this.changePart("layer3", -1);
  nLayer3 = () => this.changePart("layer3", 1);
  pLayer4 = () => this.changePart("layer4", -1);
  nLayer4 = () => this.changePart("layer4", 1);
  pLayer5 = () => this.changePart("layer5", -1);
  nLayer5 = () => this.changePart("layer5", 1);

  componentDidMount() {
    let canvas = document.createElement("canvas");
    canvas.width = SIZE;
    canvas.height = SIZE;
    this.canvas = canvas;
    
    if (this.props.isMoleTopSurface != null) {
      this.isMoleTopSurface = this.props.isMoleTopSurface;
    } else {
      this.isMoleTopSurface = false;
    }

    this.imgsRefs = this.props.imgs.slice(0);
    this.setState({ total: this.props.imgs.length, loaded: 0 })
    this.loadNextImage();
  }

  componentWillUnmount() {
    this.customImg.removeChild(this.canvas);
    this.canvas = null;
  }

  render() {
    return this.state.loaded === this.state.total ? (
      <div className="customizer pd-15">
        <Row className="legend-row" justify="space-between" type="flex">
          <Col size={6} className="legend1">
            <div>
              <div className="legend-title">{"輪郭"}</div>
              <Icon onClick={this.pLayer1} type="left" />
            </div>
            <div className="clear" />
            <div>
              <div className="legend-title">{"髪型"}</div>
              <Icon className="anticon" onClick={this.pLayer5} type="left" />
            </div>
            <div className="clear" />
            <div>
              <div className="legend-title"> {"メガネ"}</div>
              <Icon onClick={this.pLayer4} className="anticon" type="left" />
            </div>
            <div className="clear" />
            <div>
              <div className="legend-title">{"口周り"}</div>
              <Icon onClick={this.isMoleTopSurface ? this.pLayer2 : this.pLayer3} className="anticon" type="left" />
            </div>
            <div className="clear" />
            <div>
              <div className="legend-title">{"ホクロ"}</div>
              <Icon onClick={this.isMoleTopSurface ? this.pLayer3 : this.pLayer2} className="anticon" type="left" />
            </div>
          </Col>
          <Col size={17} />
          <Col size={1} className="legend2">
            <div>
              <Icon className="anticon" onClick={this.nLayer1} type="right" />
            </div>
            <div className="clear" />
            <div>
              <Icon onClick={this.nLayer5} className="anticon" type="right" />
            </div>
            <div className="clear" />
            <div>
              <Icon onClick={this.nLayer4} className="anticon" type="right" />
            </div>
            <div className="clear" />
            <div>
              <Icon onClick={this.isMoleTopSurface ? this.nLayer2 : this.nLayer3} className="anticon" type="right" />
            </div>
            <div className="clear" />
            <div>
              <Icon onClick={this.isMoleTopSurface ? this.nLayer3 : this.nLayer2} className="anticon" type="right" />
            </div>
          </Col>
        </Row>
        <Row justify="space-between" type="flex">
          <Col span={5} />
          <Col span={18}>
            <div ref={i => (this.customImg = i)} />
          </Col>
          <Col span={1} />
        </Row>
      </div>) : (<div className="progress">
        <Progress
          percent={Math.floor(this.state.loaded * 100 / this.state.total)}
          format={p => `${this.state.loaded}/${this.state.total}`}
          type="circle"
        />
      </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/Customizer.js